// Header badge: state of the real-time connection (Phase 15).
import { Radio } from 'lucide-react';
import { useRealtime } from '@/store/realtime';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';

const LOOK: Record<string, { label: string; cls: string; title: string }> = {
  live: { label: 'Live', cls: 'bg-success/15 text-success', title: 'Receiving live events' },
  connecting: { label: 'Connecting', cls: 'bg-muted text-muted-foreground', title: 'Connecting to live events' },
  reconnecting: { label: 'Reconnecting', cls: 'bg-warning/20 text-amber-700 dark:text-warning', title: 'Live events lost, retrying; pages keep polling' },
  'engine-down': { label: 'Engine down', cls: 'bg-destructive/15 text-destructive', title: 'The backend cannot reach the VoIP switch' },
  off: { label: 'Offline', cls: 'bg-muted text-muted-foreground', title: 'Not connected' },
};

export function LiveIndicator() {
  const status = useRealtime((s) => s.status);
  const l = LOOK[status] ?? LOOK.off;
  return (
    <span data-testid="live-indicator" data-status={status} title={t(l.title)}
      className={cn('inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium', l.cls)}>
      <Radio className={cn('size-3.5', status === 'live' && 'animate-pulse')} /> {t(l.label)}
    </span>
  );
}
